export enum Metrics {
  NUM_BATCHES = 'NUM_BATCHES',
  NUM_BATCHES_ACCEPTED = 'NUM_BATCHES_ACCEPTED',
  BATCH_ACCEPTANCE_PCT = 'BATCH_ACCEPTANCE_PCT',
  NUM_COMPLETED_PARTNER_PICK = 'NUM_COMPLETED_PARTNER_PICK',
  NUM_DELIVERY_BATCHES = 'NUM_DELIVERY_BATCHES',
  NUM_DELIVERY_BATCHES_ACCEPTED = 'NUM_DELIVERY_BATCHES_ACCEPTED',
  DELIVERY_BATCH_ACCEPTANCE_PCT = 'DELIVERY_BATCH_ACCEPTANCE_PCT',
  NUM_COMPLETED_PARTNER_PICK_DELIVERY = 'NUM_COMPLETED_PARTNER_PICK_DELIVERY',
  NUM_PICKUP_BATCHES = 'NUM_PICKUP_BATCHES',
  NUM_PICKUP_BATCHES_ACCEPTED = 'NUM_PICKUP_BATCHES_ACCEPTED',
  PICKUP_BATCH_ACCEPTANCE_PCT = 'PICKUP_BATCH_ACCEPTANCE_PCT',
  NUM_COMPLETED_PARTNER_PICK_PICKUP = 'NUM_COMPLETED_PARTNER_PICK_PICKUP',
  SECONDS_PER_ITEM = 'SECONDS_PER_ITEM',
  LATE_STAGE_PCT = 'LATE_STAGE_PCT',
  AVG_ORDER_RATING = 'AVG_ORDER_RATING',
  UTILIZATION_PCT = 'UTILIZATION_PCT',
  WAITING_TIME_P75_WAIT_TIME = 'WAITING_TIME_P75_WAIT_TIME',
  WAITING_TIME_AVG_WAIT_TIME = 'WAITING_TIME_AVG_WAIT_TIME',
  MAX_UPDATED_AT_DATE_TIME_UTC = 'MAX_UPDATED_AT_DATE_TIME_UTC',
}

export enum Dimensions {
  WAREHOUSE_LOCATION = 'WAREHOUSE_LOCATION',
  WAREHOUSE = 'WAREHOUSE',
  WAREHOUSE_LOCATION_GROUP = 'WAREHOUSE_LOCATION_GROUP',
  WAREHOUSE_LOCATION_CODE = 'WAREHOUSE_LOCATION_CODE',
  PARTNER = 'PARTNER',
  INSIGHTS_PORTAL_DATE_PT = 'INSIGHTS_PORTAL_DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  WEEK_TUE_PT = 'WEEK_TUE_PT',
  WEEK_WED_PT = 'WEEK_WED_PT',
  WEEK_THU_PT = 'WEEK_THU_PT',
  WEEK_FRI_PT = 'WEEK_FRI_PT',
  MONTH_PT = 'MONTH_PT',
}
